import { useProjectsStore } from '@common/modules/projects/stores'
import { useUserStore } from '@common/modules/user/stores'
import { getWorkspacesByUserId } from '@common/modules/workspaces/stores/workspaces.actions'

import { loadWorkspaceFromStore } from './loadWorkspaceFromStore'

export async function isOnboardingAlreadyComplete(): Promise<boolean> {
  await getWorkspacesByUserId()

  const user = useUserStore.getState().currentUser
  const workspace = loadWorkspaceFromStore()
  const project = useProjectsStore.getState().currentProject

  return Boolean(user && workspace && project)
}
